import React from "react";
import { Box } from "@mui/material";
import { OffenseDetails } from "./OffenseDetails";
import { DefenseDetails } from "./DefenseDetails";
import { PuntDetails } from "./PuntDetails";
import { PuntReturnDetails } from "./PuntReturnDetails";
import { KickOffReturnDetails } from "./KickOffReturnDetails";
import { useLogger } from "../../../../contexts/LoggerContext";
import { KickOffDetails } from "./KickOffDetails";
import { FieldGoalDetails } from "./FieldGoalDetails";
import { FieldGoalBlockDetails } from "./FieldGoalBlockDetails";




export const PlayDetails = () => {
  const {selectedSide} = useLogger();

  return (
    <Box sx={{ minWidth: 400, maxWidth: 1100, width: "100%" }}>
      {selectedSide === "OFFENSE" ? (
        <OffenseDetails />
      ) : selectedSide === "DEFENSE" ? (
        <DefenseDetails />
      ) : selectedSide === "KICKOFF_RETURN" ? (
        <KickOffReturnDetails />
      ) : selectedSide === "PUNT_RETURN" ? (
        <PuntReturnDetails />
      ) : selectedSide === "PUNT" ? (
        <PuntDetails />
      ) : selectedSide === "KICKOFF" ? (
        <KickOffDetails />
      ) : selectedSide === "FIELD_GOAL" ? (
        <FieldGoalDetails />
      ) : selectedSide === "FIELD_GOAL_BLOCK" ? (
        <FieldGoalBlockDetails />
      ) : null}
    </Box>
  )
};
